<template>
  <div class="spond-login">
    <nav class="navbar navbar-expand-lg navbar-light bg-light border-bottom shadow-sm mb-3">
      <div class="container">
        <router-link class="navbar-brand" to="/">
          <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="back-icon bi bi-arrow-left-short" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
          </svg>
          <span>{{$t('spondLogin.header')}}</span>
        </router-link>
      </div>
    </nav>
    <div class="container">     
      <h3>{{$t('spondLogin.subHeader')}}</h3>
      <p class="text-muted mt-2 small">
        {{$t('spondLogin.description')}}
      </p> 
      <form class=" max-width-form">
        <div class="form-group mt-4 mb-4"> 
          <label class="form-label">{{$t('spondLogin.username')}}</label> 
          <input
            autocomplete="username"
            type="text"
            class="form-control max-width-form" 
            id="username"
            ref="usernameInput"
            v-bind:placeholder="$t('spondLogin.usernamePlaceholder')"
            v-model="username"          
            @keyup.enter="focusAddPlayer"
          />
    
        </div>  
        <div class="form-group mb-4"> 
          <label class="form-label">{{$t('spondLogin.password')}}</label> 
          <input
            type="password"
            autocomplete="current-password"
            class="form-control max-width-form" 
            id="password"
            v-bind:placeholder="$t('spondLogin.passwordPlaceholder')"
            v-model="password"          
            @keyup.enter="loginToSpond()"
          />
        </div> 

        <div class="alert alert-danger mb-4" v-if="loginError">{{$t('spondLogin.errorText')}}</div>

        <div class="col-12 col-md-6 mb-4">
          <button type="button" v-on:click="loginToSpond()" class="btn btn-primary btn-block py-2 max-width-form">{{$t('spondLogin.loginButton')}}</button>
        </div>  
        <p class="text-muted small mb-4" v-html="$t('spondLogin.resetPasswordText')">
          
        </p>
      </form>
    </div>    
  </div>
</template>

<script lang="ts">
import { Vue } from "vue-class-component";
import moment from "moment";
import { set, get, keys, Store } from "idb-keyval";
import { Guid } from "guid-typescript";
import { Match } from "../models/Models";
import { SpondService } from '../services/SpondService';
import axios from 'axios';
import { inject } from 'vue';
import router from '../router';

export default class SpondLogin extends Vue {
  private username = '';
  private password = ''
  private loginError = false;
  private spondService: SpondService;

  $refs: {
    usernameInput: HTMLFormElement;
  };

  created() {
    this.spondService = inject('SpondService', new SpondService());
    
    setTimeout(() => {
      this.$refs.usernameInput.focus();
    });
  }

  goToSpondMatches() {  
    router.push({ name: "SpondGroups" });
  }

  loginToSpond() {
    this.spondService.login(this.username, this.password)
      .then(async response => {
        this.loginError = false;
        this.goToSpondMatches();
      })
      .catch(err => {
        this.loginError = true;
      });
  }
}
</script>